import { Handshake } from 'lucide-react';
import { PhaseStubPage } from '@/components/layout/PhaseStubPage';

export function AffiliatesPage() {
  return (
    <PhaseStubPage
      title="Affiliates"
      phase={6}
      modules={[
        'Affiliate partner directory with contact + payout terms',
        'Per-partner referral links with click + conversion tracking',
        'Commission ledger with monthly payout statements',
        'Attribution back to sales orders for true revenue contribution',
      ]}
      icon={Handshake}
    />
  );
}
